import $ from 'jquery';
import 'slick-carousel';

/**
 * slick適用
 * nobreak: PCサイズ表示の場合のslick解除有無
 */
export default class Slider {
    constructor(nobreak = true, dots = true) {
        this.nobreak = nobreak;
        this.threthold = 767;
        this.dots = dots;
    }

    apply() {
        $(window).on('resize', e => {
            this.setting();
        });
        this.setting();
    }

    setting() {
        const width = window.innerWidth;
        if (width <= this.threthold || !this.nobreak) {
            $('.js-slick__list')
                .not('.slick-initialized')
                .slick({
                    infinite: false,
                    dots: this.dots,
                    prevArrow:
                        '<div class="slick__arrow-prev border-color--sub-after"></div>',
                    nextArrow:
                        '<div class="slick__arrow-next border-color--sub-after"></div>',
                });
        } else {
            $('.js-slick__list.slick-initialized').slick('unslick');
        }
    }
}
